module.exports = __webpack_public_path__ + "img/passworld.792e5741.svg";